import { HttpResponse } from '@angular/common/http'

/**
 * Utility class which represents an HTTP attachment.
 */
export class HttpAttachment {
  downloadUrl: string
  filename: string

  constructor(downloadUrl: string, filename: string) {
    this.downloadUrl = downloadUrl
    this.filename = filename
  }

  static fromResponse(response: HttpResponse<any>): HttpAttachment {
    const contentType = `${response.headers.get('Content-Type')}; base64`
    const contentDisposition = response.headers.get('Content-Disposition')
    const filename = contentDisposition.split('filename=')[1]
    const downloadUrl = `data:${contentType},${response.body}`

    return new HttpAttachment(downloadUrl, filename)
  }

  download() {
    const downloadLink = document.createElement('a')
    downloadLink.href = this.downloadUrl
    downloadLink.download = this.filename
    downloadLink.click()
  }
}
